import { useLink } from '../hooks.mjs';

function Link(props) {
  useLink(props);
  return null;
}

export { Link };
